import { render, staticRenderFns } from "./ColorsSelect.vue?vue&type=template&id=679a42d0&"
import script from "./ColorsSelect.vue?vue&type=script&lang=js&"
export * from "./ColorsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ColorsSelect.vue"
export default component.exports